import { SkudCommonEndpoint } from '@/views/skud/shared/endpoint_services/skud-common-endpoint-service'
import { envelopeError } from '@/views/skud/shared/modules/skud-http'

const DIRECTION = { entry: 'Вход', exit: 'Выход' }

export class SkudPointService {
  constructor () {
    this.common = new SkudCommonEndpoint()
    this.error = null
  }

  // -> [{id, name, direction, direction_text}] или [] (ошибка в this.error).
  async getPoints (placeId) {
    const res = await this.common.getPoints(placeId)
    if (!res) {
      this.error = envelopeError(this.common.lastError) || 'Не удалось загрузить точки'
      return []
    }
    this.error = null
    return res.map(p => ({
      id: p.id,
      name: p.name,
      direction: p.direction,
      direction_text: DIRECTION[p.direction] || p.direction
    }))
  }

  // DELETE places/{placeId}/points/{pointId}/device — отзыв привязки device-id терминала.
  // -> {ok:true} | {ok:false, error}.
  async deletePointDevice (placeId, pointId) {
    return this.common.deletePointDevice(placeId, pointId)
  }
}
